<template>
  <div class="container headerborder">
    <nav
      class="navbar navbar-expand-md navbar-light"
      style="background-color: #ffffff"
    >
      <div class="container">
        <a class="navbar-brand" href=""
          ><img :src="$store.state.options.logo" height="60px" alt=""
        /></a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'home' }">
                首页
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'course', params: { page: 1, cateId: 0, courseName: '' } }">
                课程中心
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'LearnProfessional', params: { page: 1, keyword: '' } }">
                专业证书
              </router-link>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                证书查询
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li class="nav-item">
                    <router-link class="nav-link" :to="{ name: 'SelectCertifica' }">
                      查询学习认证
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{ name: 'SelectProfessional' }">
                      查询专业认证
                    </router-link>
                </li>
              </ul>
            </li>
          </ul>


          <li style="list-style-type: none" v-if="!$store.state.user.is_login">
            <router-link class="nav-link" :to="{ name: 'login' }">
                登录/注册
              </router-link>

            </li>
          <form class="d-flex flex-row-reverse" v-else-if="$store.state.user.is_login">
            
            <!-- 头像下拉选择框 -->
            <div class="dropdown">
              <img
                class="avatar nav-link dropdown-toggle"
                :src="$store.state.user.avatar"
                id="headuser"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <div
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="dropdownMenuButton"
              >
                <li class="dropdown-item">  欢迎您! {{ $store.state.user.nickName }}</li>
                <li><hr class="dropdown-divider" /></li>
                <router-link class="dropdown-item" :to="{ name: 'personInfo'} " >
                  个人信息
                </router-link>

                <router-link class="dropdown-item" :to="{ name: 'backend' }" v-if="$store.state.user.roles && ($store.state.user.roles.includes('teacher') || $store.state.user.roles.includes('admin'))">管理界面</router-link>
                <a class="dropdown-item btn btn-outline-danger" @click="logout"
                  >退出</a
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </nav>
  </div>
  <hr>
</template>
  
<script setup>
import { onMounted } from "vue";
import $ from "jquery";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from 'vuex';
import router from '@/router/index'
const store = useStore();

onMounted(() => {
  $.ajax({
    type: "post",
    url: "http://124.222.105.205:5000/visitor/api/options/GetOptions",
    data: "",
    success: function (res) {
      if (res.code == 200) {
        console.log(res);
        store.commit('updateOptions', res.data)
      } else {
        console.log("获取配置失败");
      }
    },
  });
});

// 退出登录
const logout = () => {
  ElMessageBox.confirm("是否退出登录?", "退出登录", {
    confirmButtonText: "退出",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      store.dispatch("logout", {
        success() {
          // 处理成功逻辑
          ElMessage({
            type: "success",
            message: "退出成功",
          });
          router.push({name: "login"});
        },
        error() {
          ElMessage({
            type: "error",
            message: "退出失败",
          });
        },
      });

      
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消退出",
      });
    });
};
</script>
  
  <style scoped>
.flex-grow {
  flex-grow: 1;
}
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}

.avatar {
  width: 60px;
  border-radius: 30%;
}

.avatar:hover {
  cursor: pointer;
  width: 70px;
  border-radius: 30%;
  transition: 300ms;
}
</style>
  